import { Result } from "antd";

const Page404 = () => {
  return (
    <Result
      status="404"
      title="All Slots are booked"
      subTitle="Try changing the date."
    />
  );
};
export default Page404;
